import React, { useContext } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ModalBody, ModalNext, ModalHeader, ModalFooter } from '@jutro/components';
import PropTypes from 'prop-types';
import { Button } from '@jutro/legacy/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import metadata from './InsClassHelpComponent.metadata.json5';
import styles from './InsClassHelpComponent.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function InsClassHelpComponent(props) {

    const {
        isOpen,
        onResolve,
        forms
    } = props;

     const breakpoint = useContext(BreakpointTrackerContext);
        const { onValidate } = useValidation('FormComponent');
    
        const getFormTableData = () => _.map(forms, (form) => ({
            insuranceClass: form.insuranceClass,
            product: form.product
        }));
    
        const getCell = (item, _index, property) => item[property.id];
    
        const overrideProps = {
            '@field': {
                showRequired: true,
                labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
            },
            tableFormSummary: {
                data: getFormTableData()
            },
        };
    
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                onValidate,
                getCell
            }
        };

    return (
        <ModalNext isOpen={isOpen} className={styles.modelNext}>
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.componentContent}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={onResolve}>{commonMessages.ok}</Button>
            </ModalFooter>
        </ModalNext>


    );
}

InsClassHelpComponent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func
};

InsClassHelpComponent.defaultProps = {
    onResolve: undefined
};
export default InsClassHelpComponent;